module.exports = __webpack_public_path__ + "media/site/images/icons/analytics-icon-375b5efa5ea4c2bcf5e810f8c4fabccc.svg";